import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge taught our theme. Without it, it reads the typography roles
 * (`text-label`, …) as text COLOURS, so `text-label text-success` dropped the
 * colour, and it doesn't know the named spacing steps, so `p-lg p-0` kept both.
 * Names mirror tokens/spacing.css and the `text-*` role utilities in
 * tokens/theme.css + tokens/utilities.css.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: ["xs", "sm", "md", "lg", "xl", "2xl", "3xl"],
      text: ["caption", "label", "body", "heading", "display", "display-ar", "page-title"],
    },
  },
});

/**
 * Merge Tailwind class strings with conflict resolution.
 *
 * Use everywhere a component accepts `className` from consumers — this ensures
 * that consumer overrides beat component defaults ("last wins" via `twMerge`),
 * while preserving clsx semantics (arrays, objects, falsy filtering).
 *
 * @example
 * cn("bg-surface p-md", isActive && "bg-primary-soft", props.className);
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
